<template>
    <div class="row page-row products">

        <product-modal :categories="categories" :product="selectedProduct"
                       v-on:productSaved="reloadAll()"></product-modal>

        <div class="col-sm-8">
            <div class="row mt-3">
                <b-input-group class="col-5">
                    <b-form-input v-model="search" name="search" placeholder="Search" type="text"></b-form-input>
                    <b-input-group-text>
                        <b-icon icon="search"></b-icon>
                    </b-input-group-text>
                </b-input-group>

                <b-button :disabled="!hasManagerPermission('products.edit')" size="md" variant="danger" @click="createNewProduct">
                    CREATE NEW PRODUCT
                </b-button>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-8">
            <div class="row mt-5 filters">
                <div class="col-10">
                    <b-input-group size="sm">

                        <b-select v-model="showPublicProducts" name="is_public">
                            <b-form-select-option :value="1">All products</b-form-select-option>
                            <b-form-select-option :value="0">Your Custom Products</b-form-select-option>
                        </b-select>

                        <b-select v-model="manufacturer"
                                  :options="manufacturers"
                                  name="manufacturer" @change="page = 1; loadProducts()"></b-select>

                        <b-select v-model="category" :options="categories" name="category"
                                  @change="page = 1; loadProducts()"></b-select>

                    </b-input-group>
                </div>
            </div>

            <pagination v-if="data" :align="'left'" :data="data" :limit="2" :show-disabled="true" class="mt-3"
                        @pagination-change-page="loadProducts">
                <span slot="prev-nav">&lt;</span>
                <span slot="next-nav">&gt;</span>
            </pagination>

            <product-list v-if="companyProducts && companyProducts.length > 0"
                          :products="companyProducts"
                          :project-products="projectProducts"
                          title="Custom Products"
                          v-on:reloadProjectProducts="reloadAll"
                          v-on:viewProduct="viewProduct"></product-list>
            <product-list v-if="publicProducts && publicProducts.length > 0"
                          :products="publicProducts"
                          :project-products="projectProducts"
                          title="Sponsored Products"
                          v-on:reloadProjectProducts="reloadAll"
                          v-on:viewProduct="viewProduct"></product-list>
        </div>

        <div class="col-sm-4 pt-5">
            <label class="d-block text-center">Selected products to your project</label>

            <b-list-group v-if="projectProducts.length > 0">
                <b-list-group-item v-for="product in projectProducts" :key="product.id">

                    <b-button v-if="hasManagerPermission('products.edit')" class="pull-right" size="small" type="button"
                              @click="removeProductFromProject(product)">
                        <b-icon-x-circle-fill></b-icon-x-circle-fill>
                    </b-button>

                    {{ product.name }}
                </b-list-group-item>
            </b-list-group>
            <b-alert v-else show variant="danger">No products selected. You can select products by pressing the "Select"
                button under the product.
            </b-alert>

        </div>
    </div>
</template>

<script>
import '@css/products.scss';
import axios from "axios";
import ProductModal from "./parts/ProductModal";
import ProductList from "./parts/ProductList";
import {clone} from "lodash";


export default {
    components: {ProductModal, ProductList},
    data() {
        return {
            project: null,
            page: 1,
            products: [],
            categories: [],
            manufacturers: [],
            search: '',
            searchTimeOut: null,
            data: null,
            showPublicProducts: 1,
            manufacturer: null,
            category: null,
            selectedProduct: null,
            projectProducts: [],


            companyProducts: [],
            publicProducts: []
        }
    },
    watch: {
        'project.id': function () {
            this.reloadAll();

        },
        'search': function () {
            this.page = 1;
            this.loadProducts();
        },
        'showPublicProducts': function () {
            this.loadProducts();
        }
    },
    computed: {},
    mounted() {
        this.project = this.$store.state.project;

    },
    methods: {
        reloadAll(stayOnPage){
            if(!stayOnPage){
                this.page = 1;
            }

            this.loadCategories().then(() => {
                this.loadManufacturers().then(() => {
                    this.loadProjectProducts().then(() => {
                        this.loadProducts(this.page);
                    });
                });
            });
        },
        viewProduct(product) {
            this.selectedProduct = product;

            this.$bvModal.show('product-modal');
        },
        loadProducts(page) {
            if (this.searchTimeOut) {
                clearTimeout(this.searchTimeOut);
            }

            if (!page) {
                page = 1;
            }

            this.page = page;

            let token = this.$store.state.token;
            let that = this;

            this.searchTimeOut = setTimeout(function () {
                let data = {
                    page: page,
                    is_public: that.showPublicProducts,
                    search: that.search,
                    category: that.category,
                    manufacturer: that.manufacturer,
                    paginate: true,
                    order_by: 'name',
                    order_dir: 'desc'
                };

                const url = that.$store.getters.apiProjectBase + '/products/search';
                const method = 'GET';

                axios({
                    url: url,
                    params: data,
                    data: data,
                    method: method,
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        that.data = response.data;

                        that.companyProducts = that.chunk(response.data.data.filter(product => {
                            return Number(product.belongs_to_company) === Number(that.$store.state.company.id);
                        }), 4);

                        that.publicProducts = that.chunk(response.data.data.filter(product => {
                            return product.belongs_to_company === null || Number(product.belongs_to_company) !== Number(that.$store.state.company.id);
                        }), 4);
                    })
                    .catch(error => {
                        alert('Something went wrong');
                        console.log(error);
                    });
            }, 300);


        },

        loadCategories() {
            let token = this.$store.state.token;

            let url = this.$store.getters.apiBase + '/product-categories';
            let method = 'GET';

            return axios({
                url: url,
                method: method,
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    const categories = response.data.data;
                    this.categories = [{
                        text: 'All categories',
                        value: null,
                    }];
                    this.buildCategoryHierarchy(categories);
                })
                .catch(error => {
                    alert('Something went wrong');
                    console.log(error);
                });


        },
        loadManufacturers() {
            let token = this.$store.state.token;

            let url = this.$store.getters.apiBase + '/product-manufacturers';
            let method = 'GET';

            let data = {
                is_public: this.showPublicProducts,
            }

            return axios({
                url: url,
                method: method,
                params: data,
                data: data,
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    const manufacturers = response.data;

                    this.manufacturers = [{
                        text: 'All manufacturers',
                        value: null,
                    }];

                    if (manufacturers ) {
                        Object.values(manufacturers).forEach(manufacturer => {
                            this.manufacturers.push({
                                text: manufacturer,
                                value: manufacturer
                            });
                        });
                    }

                })
                .catch(error => {
                    alert('Something went wrong');
                    console.log(error);
                });
        },

        loadProjectProducts() {
            let token = this.$store.state.token;

            let url = this.$store.getters.apiProjectBase + '/products';
            let method = 'GET';

            return axios({
                url: url,
                method: method,
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    this.projectProducts = response.data.data;
                })
                .catch(error => {
                    alert('Something went wrong');
                    console.log(error);
                });
        },

        buildCategoryHierarchy(categories, parentId) {

            parentId = parentId ? parentId : null;

            for (let i = 0; i < categories.length; i++) {
                if (categories[i].parent_id === parentId) {
                    if (parentId === null) {
                        this.categories.push({
                            id: categories[i].id,
                            text: categories[i].name,
                            value: categories[i].id,
                        });

                        this.buildCategoryHierarchy(categories, categories[i].id);

                    } else {
                        for (let parentIndex = 0; parentIndex < this.categories.length; parentIndex++) {
                            if (this.categories[parentIndex].id === parentId) {
                                if (typeof this.categories[parentIndex].label === "undefined") {
                                    this.categories[parentIndex].label = clone(this.categories[parentIndex].text);
                                    this.categories[parentIndex].options = [];
                                    delete this.categories[parentIndex].text;
                                    delete this.categories[parentIndex].value;
                                }
                                this.categories[parentIndex].options.push({
                                    text: categories[i].name,
                                    value: categories[i].id,
                                });
                            }
                        }
                    }


                }
            }

        },
        removeProductFromProject(product) {
            let token = this.$store.state.token;

            let url = this.$store.getters.apiProjectBase + '/products/' + product.id + '/remove';
            let method = 'GET';

            return axios({
                url: url,
                method: method,
                headers: {"Authorization": "Bearer " + token}
            })
                .then(response => {
                    this.loadProjectProducts();
                })
                .catch(error => {
                    alert('Something went wrong');
                    console.log(error);
                });
        },
        chunk: function (arr, size) {
            let newArr = [];
            for (let i = 0; i < arr.length; i += size) {
                newArr.push(arr.slice(i, i + size));
            }

            return newArr;
        },
        createNewProduct() {
            this.selectedProduct = null;
            this.$bvModal.show('product-modal');
        }


    }
}
</script>

